module.exports = __webpack_public_path__ + "static/media/control_de_carga3.38fb56e3.svg";